'use strict';

(function () {
  if (customElements.get('featured-blog')) return;

  class FeaturedBlog extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.slider = this.querySelector('.swiper');
      this.handleResize = debounce(this.handleResize.bind(this), 200);
    }

    connectedCallback() {
      if (this.dataset.enableCarousel !== 'true' || !this.slider) return;

      this._observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;

          this._observer.disconnect();
          this._observer = null;
          this.initSwiper();
          window.addEventListener('resize', this.handleResize);
        },
        { rootMargin: '200px' },
      );

      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      window.removeEventListener('resize', this.handleResize);
      this.destroySwiper();
    }

    initSwiper() {
      if (!this.slider || this.swiper) return;

      const slidesLength = Number(this.dataset.slidesLength) || 0;
      if (slidesLength < 2) return;

      const spaceBetween = Number(this.dataset.spaceBetween) || 16;
      const spaceBetweenMd = Number(this.dataset.spaceBetweenMd) || spaceBetween;
      const spaceBetweenLg = Number(this.dataset.spaceBetweenLg) || spaceBetweenMd;
      const requestedMobileView = Number(this.dataset.slidesPerView) || 1.1;
      const requestedDesktopView = Number(this.dataset.slidesPerViewLg) || 3;

      const maximumLoopView = Math.max(1, slidesLength - 1);
      const slidesPerView = Math.min(requestedMobileView, maximumLoopView);
      const slidesPerViewLg = Math.min(requestedDesktopView, maximumLoopView);
      const slidesPerViewMd = Math.min(
        (slidesPerView + slidesPerViewLg) / 2,
        maximumLoopView,
      );

      const autoplayEnabled = this.dataset.autoplay === 'true';
      const loopEnabled = this.dataset.loop === 'true' && slidesLength > slidesPerViewLg;
      const pauseOnHover = this.dataset.pauseOnHover !== 'false';
      const autoplayDelay = Number(this.dataset.autoplayDelay) || 4000;
      const scrollbar = this.querySelector('.swiper-scrollbar');

      const swiperParams = {
        speed: 700,
        slidesPerView,
        spaceBetween,
        loop: loopEnabled,
        rewind: !loopEnabled,
        watchOverflow: true,
        grabCursor: true,
        autoplay: autoplayEnabled
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: pauseOnHover,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: slidesPerViewMd,
            spaceBetween: spaceBetweenMd,
          },
          990: {
            slidesPerView: slidesPerViewLg,
            spaceBetween: spaceBetweenLg,
          },
        },
      };

      if (scrollbar) {
        swiperParams.scrollbar = {
          el: scrollbar,
          draggable: true,
        };
      }

      this.swiper = new Swiper(this.slider, swiperParams);
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    handleResize() {
      if (this.swiper) {
        this.swiper.update();
      } else {
        this.initSwiper();
      }
    }
  }

  customElements.define('featured-blog', FeaturedBlog);
})();
